import React, { useState, useEffect } from 'react';
import { Stack, Typography, Button, Paper } from '@mui/material';

import { ModalContainer } from '../../layout';
import { getPaymentGatewayStatus } from './gatewayStatus';
import { GATEWAY_STATUS } from '../../../utils/constants';

const PaymentMaintenance = () => {
  const [isOpenMaintenanceModal, setIsOpenMaintenanceModal] = useState(true);
  const [gatewayStatus, setGatewayStatus] = useState({
    status: GATEWAY_STATUS.ONLINE,
    message: '',
    estimatedDowntimeUntil: '',
  });

  useEffect(() => {
    const loadGatewayStatus = async () => {
      try {
        const status = await getPaymentGatewayStatus();
        setGatewayStatus(status);
      } catch (error) {
        // Silent fail to prevent blocking UI
      }
    };

    loadGatewayStatus();
  }, []);

  const handleClose = () => {
    setIsOpenMaintenanceModal(false);
  };

  if (gatewayStatus.status === GATEWAY_STATUS.ONLINE) {
    return null;
  }

  const isMaintenanceMode = gatewayStatus.status === GATEWAY_STATUS.MAINTENANCE;
  // const isOfflineMode = gatewayStatus.status === GATEWAY_STATUS.OFFLINE;

  return (
    <ModalContainer
      isOpen={isOpenMaintenanceModal}
      onClose={handleClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Paper sx={{ p: 2, m: 1 }}>
        <Stack p={2} alignItems="center">
          <Typography fontWeight="bold" color="primary">
            {isMaintenanceMode ? 'Payment System Maintenance' : 'Payment System Unavailable'}
          </Typography>
          {gatewayStatus.message ? (
            <Typography maxWidth={360} mt={2} textAlign="justify">
              {gatewayStatus.message}
            </Typography>
          ) : (
            <>
              <Typography maxWidth={360} mt={2} textAlign="justify">
                We are currently {isMaintenanceMode ? 'performing maintenance on' : 'experiencing issues with'} our
                payment system.
              </Typography>
              <Typography maxWidth={360} mt={2} textAlign="justify">
                Please check back later to complete your transaction.
              </Typography>
            </>
          )}
          {gatewayStatus.estimatedDowntimeUntil && (
            <Typography maxWidth={360} mt={2} textAlign="justify">
              <strong>Estimated completion time:</strong> {gatewayStatus.estimatedDowntimeUntil}
            </Typography>
          )}
          <Typography maxWidth={360} mt={2} textAlign="justify">
            Thank you for your patience. If your payment cannot be processed, please contact support via the support
            chat or wait until the payment system is back online.
          </Typography>
          <Button sx={{ mt: 4 }} onClick={handleClose}>
            Close
          </Button>
        </Stack>
      </Paper>
    </ModalContainer>
  );
};

export default PaymentMaintenance;
